export default __webpack_public_path__ + "static/media/reviewPreview.ffb6d8cb.png";